import { apiSlice } from "../../../api/ApiService";
import { getHeadersFromRedux } from "../../../utility/functions/common-functions";

const optInOptOutApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    updatePatientProfile: builder.mutation({
      query: ({ body }) => {
        const headers = getHeadersFromRedux();
        return {
          url: `/api/v1/Patient/patient-case`,
          method: "PUT",
          data: body,
          headers,
        };
      },
      invalidatesTags: (result, error, arg) => [
        { type: "PatientLoginWorkflow", id: arg.mrnId },
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useUpdatePatientProfileMutation } = optInOptOutApi;
export default optInOptOutApi;
